var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAddUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.5V9M14 9V11.5M14 9H16.5M14 9H11.5M9.83333 4.83333C9.83333 6.67428 8.34095 8.16667 6.5 8.16667C4.65905 8.16667 3.16667 6.67428 3.16667 4.83333C3.16667 2.99238 4.65905 1.5 6.5 1.5C8.34095 1.5 9.83333 2.99238 9.83333 4.83333ZM1.5 15.6667C1.5 12.9052 3.73858 10.6667 6.5 10.6667C9.26142 10.6667 11.5 12.9052 11.5 15.6667V16.5H1.5V15.6667Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/addUser.f811095e.svg";
export { ForwardRef as ReactComponent };